/* eslint-disable linebreak-style */
/* eslint-disable prefer-template */
/* eslint-disable no-multi-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable class-methods-use-this */
import _pickBy from 'lodash/pickBy';
import _filter from 'lodash/filter';
import camelCase from './helpers/camelCase';

/**
 * Utility to trigger JS code based on clasname routing
 */
export default class JSManager {
  /**
   * Generic constructor
   * @constructor
   * @param {object} namespace | JS Object
   * @param {string} routes | Key name containing routes
   */
  constructor(namespace, routes = 'routes') {
    this.namespace = namespace; // WP Localized head obj
    this.routesKey = routes;
    // eslint-disable-next-line max-len
    this.extendedR = _pickBy(this.namespace[this.routesKey], (v) => v.extends && v.extends instanceof Array);
  }

  // eslint-disable-next-line consistent-return
  fireRoute(route, funcname, args) {
    let fire;

    funcname = funcname === undefined ? 'init' : funcname;
    fire = route !== '';
    fire = fire && this.namespace[this.routesKey][route];
    fire = fire && typeof this.namespace[this.routesKey][route][funcname] === 'function';

    if (fire) return this.namespace[this.routesKey][route][funcname](args);
  }

  /**
   * Meant to be run on load
   * @info It handles all necessary JS init from routes
   */
  sequence(route) {
    this.fireRoute(route);
    this.fireRoute(route, 'complete');
  }

  /**
   * Meant to be run on load
   * @info It handles all necessary JS init from routes
   */
  loadEvents() {
    this.fireRoute('common');
    for (const cls of document.body.classList) {
      const route = camelCase(cls.toLowerCase().replace(/-/g, '_'));
      // Fire Manual Routes
      this.sequence(route);
      // Additional Extended Routes
      _filter(this.extendedR, (v, k) => v.extends.includes(cls) && this.sequence(k));
    }
    this.fireRoute('common', 'complete');
  }
}
